<template>
  <div class="con_out">
    <!-- <div class="el-menu-demo">
      <div class="title">
        <el-image style="height:100%;width:100%" src="https://ui-repository.zhugen.tech/guanwang/logo.png" />
      </div>
      <el-menu
      v-if="phone"
        :default-active="activeIndex"
        mode="horizontal"
        @select="handleSelect"
        background-color="#fff"
        active-text-color="#1A7D3A"
        text-color="#333"
        router
      >
        <el-menu-item index="index">展示中心</el-menu-item>
        <el-menu-item index="about">关于我们</el-menu-item>
        <el-menu-item index="org">组织架构</el-menu-item>
        <el-menu-item index="honey">荣誉资质</el-menu-item>
        <el-menu-item index="product">产品中心</el-menu-item>
        <el-menu-item index="project">项目落地</el-menu-item>
      </el-menu>
   
     </div> -->
 
     <router-view ref="routerView" v-if="refreshKeepalive"/>

    
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "index",
      activeIndex2: "index",
      depath:'/index',
      keepaliveArr: [],
      refreshKeepalive: true,
      phone:false
    };
  },
  mounted(){
    //    if (this._isMobile()) {
    //  //手机端
    //  this.phone=true
    // } else {
    //   //电脑端
    //   this.phone=false
    // }
    
     
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key,keyPath)
      this.activeIndex=key
      this.keepaliveArr.push(key)
    },
    _isMobile() {
	 let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
	 return flag;
     }
  },
};
</script>
<style>
*{
  margin: 0;
  padding: 0;
}
.el-menu-demo{
    padding: 0 20px;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.title {
  color: #333;
  align-items: center;
  height: 40px;
  width: 75px;
 
}


</style>
<style>
@media screen and (min-width: 400px) {
.el-menu-demo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  height: 60px;
}
.title {
  
  font-size: 20px;
  color: #333;
  align-items: center;
  height: 40px;
  width: 75px;
 
}
.img_item {
  width: 100%;
  height: 300px;
}
}
</style>

  
 
  
